<template>
	<div>
		<a-row type="flex" class="mb-5">
			<a-col :span="24">
				<detail-title :detail="getCurrentProfile" v-if="!loadingProfile" />
			</a-col>
		</a-row>

		<a-row type="flex">
			<a-col :span="24">
				<div class="card-container">
					<a-tabs type="card" defaultActiveKey="posts" class="post-list">
						<a-tab-pane tab="Posts" key="posts">
							<div class="px-3">
								<a-row type="flex">
									<a-col :span="24">
										<detail-search />
									</a-col>
								</a-row>
							</div>
						</a-tab-pane>
						<a-tab-pane tab="Activity" key="activity">
							<div class="px-3">
								<detail-activity :detailId="+$route.params.profileId" />
							</div>
						</a-tab-pane>
					</a-tabs>
				</div>
			</a-col>
		</a-row>
	</div>
</template>
<script>
import * as ACTIONS from '../../store/actions'
import { mapGetters, mapActions } from 'vuex'

import DetailActivity from '../../components/widgets/Detail/Activity'
import DetailTitle from '../../components/widgets/Detail/Title'
import DetailSearch from '../../components/widgets/Detail/Search'

export default {
	name: 'Profile',
	components: {
		DetailTitle,

		DetailSearch,
		DetailActivity,
	},
	data: function() {
		return {
			loadingProfile: true,
			// tabKey: 'posts',
		}
	},
	created() {
		this.loadProfile(this.$route.params.profileId).then(res => {
			this.loadingProfile = false
		})
	},
	methods: {
		...mapActions({
			loadProfile: ACTIONS.DETAIL.BY_ID,
		}),
	},
	computed: {
		...mapGetters(['getCurrentProfile']),
	},
}
</script>

<style lang="scss">
@import './style.module.scss';
</style>
